import DateFormat from "../modules/date-format";

export default class Header {

	static getHolderSelectors = () => ['.main-header'];

	/** @type {HTMLElement} */
	#holderElement;
	#checkInPicker = null;
	#checkOutPicker = null;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#headerScroll();
		this.#bookingOverlay(document.querySelector('.booking-overlay'));
		const navOverlay = document.querySelector('.navigation-overlay');
		document.querySelectorAll('.navigation-overlay-toggle').forEach(btn =>
			btn.addEventListener('click', () => navOverlay.classList.toggle('open', !navOverlay.classList.contains('open'))));
	}

	#headerScroll() {

		const heroExists = !!document.querySelector('.hero-element');
		if (!heroExists) {
			this.#holderElement.classList.add('scrolled');
			return;
		}

		const SCROLL_BREAKPOINT = 300;
		let scrolled = window.scrollY > SCROLL_BREAKPOINT;
		this.#holderElement.classList.toggle('scrolled', scrolled);
		window.addEventListener('scroll', () => {
			if (scrolled !== window.scrollY > SCROLL_BREAKPOINT) {
				scrolled = !scrolled;
				this.#holderElement.classList.toggle('scrolled', scrolled);
			}
		});
	}

	/**
	 * @param {HTMLElement} element
	 */
	#bookingOverlay(element) {
		if (!element) {
			return;
		}
		const radioInputs = Array.from(element.querySelectorAll('input[type="radio"]'));
		const radioLabels = radioInputs.map(i => i.closest('label')).filter(l => l);

		radioInputs.forEach(i => {
			i.addEventListener('change', (event) => {
				radioLabels.forEach(l => l.classList.remove('selected'));
				i.closest('label')?.classList.add('selected');
				let checkIn = 0;
				let checkOut = 1;
				if (event.currentTarget.value === 'tomorrow') {
					checkIn = 1;
					checkOut = 2;
				} else if (event.currentTarget.value === 'weekend') {
					checkIn = 6 - new Date().getDay();
					checkOut = 7 - new Date().getDay();
				}
				this.#checkOutPicker.setDate(DateFormat.add(new Date(), checkOut, 'days'));
				this.#checkInPicker.setDate(DateFormat.add(new Date(), checkIn, 'days'));
			});
		});

		let hasOpenedBookingOverlay = false;
		document.querySelectorAll('.booking-overlay-toggle').forEach(btn => {
			btn.addEventListener('click', () => {

				const openState = element.getAttribute('data-open-state');
				if (['opening', 'closing'].includes(openState)) {
					return;
				}




				const isOpen = openState === 'opened';
				element.setAttribute('data-open-state', isOpen ? 'closing' : 'opening');

				window.setTimeout(() => {
					element.setAttribute('data-open-state', isOpen ? 'closed' : 'opened');
				}, 1000);



				// element.classList.toggle('open', !isOpen);


				if (!hasOpenedBookingOverlay) {
					window.loadScript('pikaday').then(() => this.#initDatepicker(element))
					hasOpenedBookingOverlay = true;
				}
			});
		});
	}

	/**
	 * @param {HTMLElement} bookingOverlay
	 */
	#initDatepicker(bookingOverlay) {
		const checkInInput = bookingOverlay.querySelector('#bo--check-in-input');
		const checkOutInput = bookingOverlay.querySelector('#bo--check-out-input');
		this.#checkInPicker = new Pikaday({
			field: document.getElementById('bo--check-in'),
			toString: (date) => DateFormat.format(date, 'd mmm yyyy'),
			defaultDate: new Date(),
			setDefaultDate: true,
			minDate: new Date(),
			onSelect: (date) => {
				checkInInput.value = DateFormat.format(date, 'yyyy-mm-dd');
				if (!checkOutInput.value || new Date(checkOutInput.value).valueOf() < date.valueOf()) {
					this.#checkOutPicker.show();
				}
			}
		});
		this.#checkOutPicker = new Pikaday({
			field: document.getElementById('bo--check-out'),
			minDate: new Date(),
			defaultDate: DateFormat.add(new Date(), 2, 'days'),
			setDefaultDate: true,
			toString: (date) => DateFormat.format(date, 'd mmm yyyy'),
			onSelect: (date) => {
				checkOutInput.value = DateFormat.format(date, 'yyyy-mm-dd');
			}
		});
	}

}
